/**
 * client-bundle.js
 *
 * This is the main entry point for react-on-rails.
 * Components are registered here with ReactOnRails.register().
 */

import './react_front-end.scss';
import 'src/vendor/rails';
import './i18n';

import ReactOnRails from 'react-on-rails/client';

// Import React components
// Marketplace components
import { Home } from '@/features/marketplace/home/pages/home';
import { AboutUs } from '@/features/marketplace/about-us/pages/about-us';
import { Press } from '@/features/marketplace/press/pages/press';
import { ComingSoon } from '@/features/marketplace/coming-soon/pages/coming-soon';
import HouseDetails from '@/features/marketplace/coming-soon/pages/house-details';

// Admin components
import { ContractsScreen } from '@/pages/admin/contracts';
import { RentsScreen } from '@/pages/admin/rents';
import { TransactionsScreen } from '@/pages/admin/transactions';
import { PayoutSummaryScreen } from '@/pages/admin/payout_summary';
import { StatsDashboardScreen } from '@/pages/admin/stats';
import { BroadcastMessagesScreen } from '@/pages/admin/community_broadcast_messages';

// Register all components with ReactOnRails
ReactOnRails.register({
  // Marketplace
  Home,
  AboutUs,
  Press,
  ComingSoon,
  HouseDetails,

  // Admin
  ContractsScreen,
  RentsScreen,
  TransactionsScreen,
  PayoutSummaryScreen,
  StatsDashboardScreen,
  BroadcastMessagesScreen,
});
